// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import Result from './Result';

const ResultList = ({ entries = [] }) => (
  <div className="search-modal-results-list">
    <div className="wp-block-deepsea-columns has-3-columns wp-block-columns">
      {entries.map((entry) => (
        <Result key={entry.id} entry={entry} />
      ))}
    </div>
  </div>
);

export default ResultList;
